/**
 * fieldErrors (KAN-742)
 *
 * Turns a DRF validation error body ({"field": ["msg", ...]}) into one readable
 * line: the first message of every field, prefixed by the field's label
 * ("Сайт: Введите корректный адрес сайта."). Bodies of any other shape fall back
 * to the shared extractErrorMessage.
 */
import { extractErrorMessage } from './extractErrorMessage';

export function formatFieldErrors(
  err: unknown,
  labels: Record<string, string>,
  fallback: string
): string {
  const data = (err as { response?: { data?: unknown } } | null)?.response?.data;
  if (data && typeof data === 'object' && !Array.isArray(data)) {
    const parts = Object.entries(data as Record<string, unknown>)
      .map(([field, value]) => {
        const first = Array.isArray(value) ? value[0] : value;
        if (typeof first !== 'string' || first === '') return null;
        const label = labels[field];
        return label ? `${label}: ${first}` : first;
      })
      .filter((part): part is string => part !== null);
    if (parts.length > 0) {
      return parts.join('; ');
    }
  }
  return extractErrorMessage(err, fallback);
}

/**
 * KAN-826: the first message of every field of a DRF 400 body
 * ({"inn": ["msg"]} -> {inn: "msg"}), to show under the fields.
 * Any other body gives an empty map.
 */
export function fieldErrorMap(err: unknown): Record<string, string> {
  const data = (err as { response?: { data?: unknown } } | null)?.response?.data;
  const result: Record<string, string> = {};
  if (!data || typeof data !== 'object' || Array.isArray(data)) return result;
  for (const [field, value] of Object.entries(data as Record<string, unknown>)) {
    const first = Array.isArray(value) ? value.find((item) => typeof item === 'string' && item !== '') : value;
    if (typeof first === 'string' && first !== '') result[field] = first;
  }
  return result;
}
